import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import App from "../../../FeedContainer/FeedImage/demo/App";
import '../TabPanel.css';

import $ from "jquery";
import "./UserGallery.css";

function iconStyles() {
  return {
    successIcon: {
      color: 'green',
    },
    errorIcon: {
      color: 'red',
    },
  }
}


const useStyles = makeStyles(theme => ({
  root: {
   
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    backgroundColor: theme.palette.background.paper,
  },
  gridList: {
    width: (screen.width - 120),
    height: 1000,
  },
  
  icon: {
    color: 'rgba(255, 255, 259, 0.54)',
  },
}));

const handleScroll = (props) =>{
  if ($(window).scrollTop() + $(window).height()  ==  $(document).height()) {
      if(props.totalAlbumPage > props.albumPagination){
              
      }
    }
}

export default function UserUpload(props) {

  window.addEventListener('scroll', handleScroll(props), true);
  const iconclasses = makeStyles(iconStyles)();
  const classes = useStyles();
  const open = true;
  const {uploadList,totalUpload,albumPagination,uploadCarousal} = props.galleryDetails;
 
  const openCarousal = (position) => {
   props.changeCarousal(position);
  }


  $('#aurorotate').on('show', function() {
    console.log('#foo is now visible');
 });

  const changeIndex = (e) => {
    $('#slide1').parent().attr('aria-hidden','true');
    $('#slide7').parent().attr('aria-hidden',false);
  }

  $( ".checkApp" ).click(function() {
    console.log('checkApp');
    $("#appModal").modal('show');
  });
  
  return (
    <div className="container gallery_section">
        <App 
            currentActiveImage = {props.uploadCarousal} 
            media_details      = {uploadList} 
            carousalFeed       = {0}
            post_my_reaction   = ''
            post_total_reaction= '0'
            post_total_comment = '0'
            post_total_share   = '0' 
            position           = 'uploads'
        />
    </div>
  );
}
